import { useState } from "react";
import { __ } from "services/Translator";
import { useHistory, mapHistoryRow } from "./useCashierData";
import InfoCard from "./InfoCard";
import TxRow from "./TxRow";

// historyFor values accepted by POST /history/transactions (CashierController@
// transactionHistory). "All" = deposits + withdrawals. Bonus/free-spin rows are
// not returned by this endpoint, so they are honestly absent (not faked).
const TYPE_TABS = [
  { key: "All", label: "All" },
  { key: "Deposits", label: "Deposits" },
  { key: "Withdrawals", label: "Withdrawals" },
];

const DATE_INPUT_STYLE = {
  flex: "1 1 120px",
  minWidth: 0,
  padding: "10px 12px",
  borderRadius: "12px",
  background: "var(--glass-2)",
  border: "1px solid var(--stroke-soft)",
  color: "var(--ink)",
  fontFamily: "inherit",
  fontSize: "12.5px",
  colorScheme: "dark",
};

export default function HistoryView() {
  const { rows, hasMore, loading, error, filters, applyFilters, loadMore } = useHistory();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const setType = (key) => {
    if (key !== filters.historyFor) applyFilters({ historyFor: key });
  };
  const applyDates = () => applyFilters({ startDate: startDate || null, endDate: endDate || null });
  const clearDates = () => {
    setStartDate("");
    setEndDate("");
    applyFilters({ startDate: null, endDate: null });
  };

  const hasDateFilter = !!(startDate || endDate || filters.startDate || filters.endDate);
  const isInitialLoading = loading && rows.length === 0;

  return (
    <div className="stack">
      <InfoCard>
        <div className="cattabs" style={{ marginBottom: "12px" }}>
          {TYPE_TABS.map((t) => (
            <div
              key={t.key}
              className={filters.historyFor === t.key ? "cattab sel" : "cattab"}
              role="button"
              tabIndex={0}
              aria-pressed={filters.historyFor === t.key}
              onClick={() => setType(t.key)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setType(t.key);
                }
              }}
            >
              {__(t.label)}
            </div>
          ))}
        </div>
        <div style={{ display: "flex", gap: "9px", alignItems: "center", flexWrap: "wrap" }}>
          <input
            type="date"
            aria-label={__("Start date")}
            value={startDate}
            max={endDate || undefined}
            onChange={(e) => setStartDate(e.target.value)}
            style={DATE_INPUT_STYLE}
          />
          <input
            type="date"
            aria-label={__("End date")}
            value={endDate}
            min={startDate || undefined}
            onChange={(e) => setEndDate(e.target.value)}
            style={DATE_INPUT_STYLE}
          />
          <button className="miniclaim" onClick={applyDates} disabled={loading}>
            {__("Apply")}
          </button>
          {hasDateFilter ? (
            <button className="miniclaim ghost" onClick={clearDates} disabled={loading}>
              {__("Clear")}
            </button>
          ) : null}
        </div>
      </InfoCard>

      <InfoCard>
        <div className="hist-scroll">
          {isInitialLoading ? (
            <div className="note-line">{__("Loading...")}</div>
          ) : error && rows.length === 0 ? (
            <div className="note-line">
              {__("We could not load your transactions right now. Please try again.")}
            </div>
          ) : rows.length ? (
            rows.map((row, i) => (
              <TxRow key={`${row.id || row.transaction_id || "tx"}-${i}`} row={mapHistoryRow(row)} />
            ))
          ) : (
            <div className="note-line">
              {hasDateFilter ? __("No transactions match these filters.") : __("No transactions yet.")}
            </div>
          )}
          {hasMore ? (
            <button
              className="miniclaim ghost"
              style={{ display: "block", margin: "12px auto 4px" }}
              onClick={loadMore}
              disabled={loading}
            >
              {loading ? __("Loading...") : __("Load more")}
            </button>
          ) : null}
        </div>
      </InfoCard>
    </div>
  );
}
